<template>
  <vs-switch
    id="campaigns-table-switch-button"
    style="margin-top: 16px;"
    :disabled="params.data.version !== 'v3'"
    @click="updateCampaignActivationStatus"
    v-model="switchStatus"></vs-switch>
</template>

<script>
export default {
  data () {
    return {
      switchStatus: false
    }
  },
  beforeMount () {
    this.switchStatus = this.params.data.activation_status === 1
  },
  methods: {
    async updateCampaignActivationStatus (event) {
      if (this.params.data.version === 'v2') {
        return
      }

      // send to backend
      let response = {}
      try {
        response = await this.changeCampaignStatus(this.params.data.id, event.target.value !== 'true')
      } catch (e) {
        this.switchStatus = !this.switchStatus
        return
      }

      // update the current row
      this.updateCurrentRow(
        response.data.payload.activation_status,
        response.data.payload.camapign_aggregated_status
      )

      this.$gtag.event('toggle_campaign')
      // update parent component
      this.updateCards()
    },

    async changeCampaignStatus (id, activation_status) {
      return await window.axios.post(
        `/campaigns/${id}/update-activation-status`,
        {
          status: activation_status ? 'Active' : 'Paused',
          _method: 'PATCH'
        }
      )
    },

    updateCurrentRow (activation_status, camapign_aggregated_status) {
      this.params.node.setData({
        ...this.params.node.data,
        activation_status,
        aggregated_status: camapign_aggregated_status
      })

      this.$nextTick(() => {
        this.params.api.refreshCells({
          rowNodes: [this.params.node],
          force: true
        })
      })
    },

    updateCards () {
      // choose ONE way of the next two
      this.$root.$emit('update-insights-cards')
    }
  }
}
</script>

<style lang="scss" scoped>
  .vs-switch-primary {
    background: red;
  }

  .vs-switch-primary.vs-switch-active {
    background: rgba(var(--vs-primary), 1);
  }
</style>
